<template>
  <div v-if="visible">
    <div :style="{margin: '0px 30px 15px', paddingTop: '35px',fontSize: '15px'}">
    </div>
    <div
      class="innerbox"
      :style="{borderRadius: '5px',height:'530px',margin: '0px 30px',backgroundColor: 'white',overflow:'auto', textAlign: 'center'}"
    >
      <img
        src="@/assets/error.png"
        :style="{height:'25%',width:'15%',marginTop: '100px'}"
      />
      <p :style="{marginTop: '20px'}">数据加载失败，请<a @click="reloadChange">返回重试！</a></p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ErrorForm',
  data () {
    return {
      visible: false
    }
  },
  created () {
    // this.dataForm = this.value
  },
  methods: {
    handleOpen () {
      this.visible = true
    },
    reloadChange () {
      this.visible = false
      this.$emit('reloadChange')
    }
  }
}
</script>
